import {
  line,
  moveOnLine,
  onLine,
  place,
  takeBack,
} from "./fuxi-tile-moves.js";
import { type Point, dropIndex, overLine } from "./tile-drop.js";

/**
 * Where a dragged tile is shown landing, and where it lands once let go.
 * `./tile-drag.ts` is the dragging.
 */

/** One drag under way. */
export interface Drag {
  readonly tile: HTMLElement;
  readonly card: Element;
  readonly start: Point;
  ghost?: HTMLElement;
  mark?: HTMLElement;
}

/** The tile on the line a point drops in front of, or nothing for the end. */
function dropBefore(drag: Drag, point: Point): Element | null {
  const placed = [...drag.card.querySelectorAll(onLine)].filter(
    (each) => each !== drag.tile,
  );

  return (
    placed[
      dropIndex(
        point,
        placed.map((each) => each.getBoundingClientRect()),
      )
    ] ?? null
  );
}

/** Show where the tile would land, or nothing where it is off the line. */
export function showMark(drag: Drag, point: Point): void {
  const onto = drag.card.querySelector(line)!;

  drag.mark ??= Object.assign(drag.tile.ownerDocument.createElement("span"), {
    className: "cb-fuxi-drop-mark",
  });

  if (overLine(point, onto.getBoundingClientRect())) {
    onto.insertBefore(drag.mark, dropBefore(drag, point));
  } else {
    drag.mark.remove();
  }
}

/** Land the tile where the pointer was let go. */
export function drop(drag: Drag, point: Point): void {
  const { tile, card } = drag;
  const origin = drag.ghost?.getBoundingClientRect();
  const onto = card.querySelector(line)!;
  const landed = overLine(point, onto.getBoundingClientRect());

  drag.mark?.remove();

  const before = landed ? dropBefore(drag, point) : null;

  if (tile.matches(onLine)) {
    if (landed) {
      moveOnLine(card, tile, before, origin);
    } else {
      takeBack(card, tile, false, origin);
    }
  } else if (landed) {
    place(card, tile, false, before, origin);
  }
}
